/* wg-lock-header.js - Wade Greens
   -----------------------------------------------------------------------
   Publishes the frozen scroll offset as --wg-lock-y while the page is
   locked, so wg-sticky-header-full.css can hold the header in place
   without taking it out of flow.

   WHY A VARIABLE AND NOT position:fixed
   Opening a modal or a right-hand panel sets overflow:hidden on the root.
   That removes the scrollport, and position:sticky cannot stick inside a
   box that no longer scrolls - the header drops back to its place in the
   document and disappears up the page.

   The obvious repair, position:fixed, trades one bug for a worse one: it
   pulls the header out of flow, the 104px it occupied collapses, and
   every section below jumps up by that much. Behind a full-screen modal
   that is invisible; behind the cart drawer, which covers only the right
   420px, the whole page lurches.

   position:relative keeps the space. The header's box stays exactly where
   it is and only its painted position shifts, by `top`. The page is
   frozen while a lock is open, so the scroll offset at the moment the
   lock engages is precisely how far down the header must be painted to
   sit at the top of the viewport. That number is what this script writes.

   WHAT COUNTS AS A LOCK
   html.modal-lock (the four header modals, wishlist, contact) and, on
   <body>, cart-sidebar-show, auth-sidebar-show, lang-currency-sidebar-show
   and menu_open. Both elements are watched, because the theme puts the
   class on whichever one suits the panel.

   The value is written once per lock and not refreshed while the lock is
   open - the page cannot scroll during that time, so it cannot go stale,
   and rewriting it would make the header twitch.

   No scroll listener, no polling. Two class observers, and they only ever
   fire when a panel opens or closes.
   ----------------------------------------------------------------------- */

(function () {
  'use strict';

  var LOCKS = /(?:^|\s)(?:modal-lock|cart-sidebar-show|auth-sidebar-show|lang-currency-sidebar-show|menu_open)(?:\s|$)/;
  var root = document.documentElement;

  function locked() {
    return LOCKS.test(root.className) ||
           (document.body ? LOCKS.test(document.body.className) : false);
  }

  function sync() {
    if (locked()) {
      /* Write once per lock. The page is frozen, so it cannot go stale. */
      if (!root.style.getPropertyValue('--wg-lock-y')) {
        root.style.setProperty('--wg-lock-y', Math.round(window.pageYOffset) + 'px');
      }
    } else {
      root.style.removeProperty('--wg-lock-y');
    }
  }

  function start() {
    sync();
    var obs = new MutationObserver(sync);
    obs.observe(root, { attributes: true, attributeFilter: ['class'] });
    if (document.body) {
      obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
